export default () => ({
  recalculate: '',

  recalculateTotals() {
    this.recalculate = '1'
    setTimeout(() => this.$el.closest('form').requestSubmit(), 10)
  },
})
